import React from 'react';

import NumberInputFormField from '@components/form-fields/NumberInputFormField';
import SelectFormField from '@components/form-fields/SelectFormField';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';

import { useTravelDetailsLovs } from '../hooks';
import { FormValues } from '../types';

import { getIn, useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';

type Props = {
  disabledForm: boolean;
};

const useStyles = makeStyles()(() => ({
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '10px 1.75%',
    alignItems: 'center'
  }
}));

const TravelDetailsWidgetAtom: React.FC<Props> = ({ disabledForm }) => {
  const { classes } = useStyles();
  const { departure, destination } = useTravelDetailsLovs();

  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<FormValues>();

  const travelDetails = (values as any).travelDetails || {};

  const setTravelDetails = (name: string, v: unknown) =>
    setFieldValue(`travelDetails.${name}`, v);

  const err = (field: string) =>
    getIn(touched, `travelDetails.${field}`)
      ? (getIn(errors, `travelDetails.${field}`) as string) || ''
      : '';

  return (
    <WidgetPaper>
      <WidgetSection title="Travel Details">
        <div className={classes.fieldRow}>
          <SelectFormField
            name="travelDetails.departureId"
            title="Departure*"
            placeholder="Departure"
            value={travelDetails?.departureId || ''}
            onBlur={(_, e) => handleBlur(e)}
            error={err('departureId')}
            onChange={(v) => setTravelDetails('departureId', v)}
            disabled={disabledForm}
            selectOptions={departure}
            material
          />

          <SelectFormField
            name="travelDetails.destinationId"
            title="Destination*"
            placeholder="Destination"
            value={travelDetails?.destinationId || ''}
            onBlur={(_, e) => handleBlur(e)}
            error={err('destinationId')}
            onChange={(v) => setTravelDetails('destinationId', v)}
            disabled={disabledForm}
            selectOptions={destination}
            material
          />

          <NumberInputFormField
            name="travelDetails.duration"
            title="Duration (in Days)*"
            placeholder="Duration"
            value={travelDetails?.duration || ''}
            error={err('duration')}
            onBlur={(e) => handleBlur(e)}
            onChange={(e) => setTravelDetails('duration', e.target.value)}
            disabled
            material
            minValue={0}
          />
        </div>
      </WidgetSection>
    </WidgetPaper>
  );
};

export { TravelDetailsWidgetAtom };
